import React from "react";

// components
import Cookies from 'universal-cookie';
import Utils from "../../utils/utils";
import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import { Page, Text, View, Document, StyleSheet, Image  } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import translateString from "../../utils/Locales";
import getRataStatusAll from "../../services/getRataStatusAll";
import getStudenti from "../../services/getStudenti";
import getCorsi from "../../services/getCorsi";
import getClient from "../../services/getClient";

let t = translateString;

export default class PdfInvoice extends React.Component {

  constructor(props){
    super (props)
    this.state = {
      isLoading: true,
    };
  }

  async componentDidMount(){

    moment.locale(t('language_string'));

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    let currentRata = cookies.get('currentRata', { path: '/' });

    this.logoUrl = window.sessionStorage.getItem('logo');
    
    this.cliente = await getClient('', '', cookies.get('db', { path: '/' }));
    let rate = await getRataStatusAll(username, token);
    let studenti = await getStudenti(username, token);
    let corsi = await getCorsi(username, token);

    this.rata = rate.find((rata) => rata.id === currentRata);

    this.studente = studenti.find((s) => s.id === this.rata.id_studente);
    this.corso = corsi.find((c) => c.id === this.rata.id_corso);

    if (!this.rata) {
        Utils.showInfo(t('no_rata'));
        window.history.go(-1);
    }

    this.setState({ isLoading: false });

  }

  render () {

    if (this.state.isLoading) return <div />;

    let importoImponibile = (100 * parseFloat(this.rata.importo))/122;
    let iva = (importoImponibile * 0.22).toFixed(2);

    return (
    <div style={{width: '100%', height: '100%'}} key={Math.random()}> 
      <PDFViewer style={{width: '100%', height: '100%'}}>
          <Document>
              <Page size="A4" style={{ paddingTop: 80, paddingBottom: 50 }} orientation="portrait" wrap>
                <View style={{ marginTop: -40, marginLeft: 30 }}>
                  <Image style={{position: 'absolute', top: 0, padding: 10, left: 10, width: 'auto', height: 60}} src={ this.logoUrl ? this.logoUrl : require('../../images/icon.png') } />
                  <View style={{ position: 'absolute', top: 80, left: 20, width: 250, borderColor: '#C4C4C4', borderWidth: 1, borderRadius: 10, backgroundColor: '#E8E8E8', paddingVertical: 10, paddingHorizontal: 20 }}>
                    <Text style={{ fontSize: 15, fontFamily: 'Courier-Bold', marginTop: 10 }}>{t('ric_fiscale')}</Text>
                    <Text style={{ fontSize: 12, fontFamily: "Courier" }}>{t('numero')}: {this.rata.n_fattura ? this.rata.n_fattura : 'PROFORMA/' + moment().format('yyyy')}</Text>

                    <Text style={{ fontSize: 12, fontFamily: "Courier-Bold", marginTop: 10 }}>{t('em_da')}:</Text>
                    <Text style={{ fontSize: 12, fontFamily: "Courier" }}>{this.cliente.ragioneSociale}</Text>
                    <Text style={{ fontSize: 12, fontFamily: "Courier" }}>{this.cliente.indirizzo}, {this.cliente.citta}, {this.cliente.CAP}, {this.cliente.provincia}</Text>
                    <Text style={{ fontSize: 12, fontFamily: "Courier" }}><Text style={{ fontFamily: 'Courier-Bold'}}>{t('il')}:</Text>{this.rata.data_pagamento ? this.rata.data_pagamento : moment().format('DD/MM/yyyy')}</Text>
                    <View style={{ height: 10, width: '100%' }} />
                  </View>

                  <View style={{ position: 'absolute', top: 80, left: 270, width: 250, height: 150, paddingLeft: 30, paddingTop: 30 }}>
                        <Text style={{ fontSize: 12 }}>{this.studente.sesso === 'M' ? t('gent_m') : this.studente === 'F' ? t('gent_f') : t('gent')}</Text>
                        <Text style={{ fontSize: 12, marginTop: 10 }}>{this.studente.cognome} {this.studente.nome}</Text>
                        <Text style={{ fontSize: 12 }}>{this.studente.indirizzo} {this.studente.citta ? (', ' + this.studente.citta) : ''}</Text>
                        { this.studente.codiceFiscale ? <Text style={{ fontSize: 12, marginTop: 20, fontWeight: 'medium' }}>{t('codice_fiscale')}: {this.studente.codiceFiscale}</Text>  : <View /> }
                  </View> 

                  <View style={{ marginTop: 290, marginLeft: 20, width: 500 }}>
                    <View style={{ flexDirection: 'row', width: 500 }}>
                      <View style={{ position: 'relative', width: 280, left: 0, borderWidth: 1, borderColor: '#C4C4C4', textAlign: 'center' }}><Text>{t('articolo')}</Text></View>
                      <View style={{ position: 'absolute', left: 280, width: 73.5, borderWidth: 1, borderColor: '#C4C4C4', textAlign: 'center', marginLeft: -1 }}><Text>{t('qta')}</Text></View>
                      <View style={{ position: 'absolute', left: 353, width: 148.5, borderWidth: 1, borderColor: '#C4C4C4', textAlign: 'center', marginLeft: -1 }}><Text>{t('prezzo')}</Text></View>
                    </View> 
                    <View style={{ flexDirection: 'row', width: 500, marginTop: -1 }}>
                      <View style={{ position: 'relative', width: 280, left: 0, borderWidth: 1, borderColor: '#C4C4C4', textAlign: 'left', paddingVertical: 10, paddingHorizontal: 20, paddingBottom: 100 }}><Text style={{ fontSize: 12 }}>{t('pag_rata')}: {this.corso.name} {t('in_aa')} { this.corso.anno_accademico }</Text></View>
                      <View style={{ position: 'absolute', left: 280, width: 73.5, height: '100%', borderWidth: 1, borderColor: '#C4C4C4', alignItems: 'center', marginLeft: -1, paddingVertical: 10, paddingHorizontal: 20 }}><Text style={{ fontSize: 12 }}>1.00</Text></View>
                      <View style={{ position: 'absolute', left: 353, width: 148.5, borderWidth: 1, height: '100%', borderColor: '#C4C4C4', alignItems: 'center', marginLeft: -1, paddingVertical: 10, paddingHorizontal: 20 }}><Text style={{ fontSize: 12 }}>€ {importoImponibile.toFixed(2)}</Text></View>
                    </View> 
                  </View>
                </View>

                <View style={{ marginTop: 50, marginLeft: 50, width: 500, borderWidth: 1, borderColor: '#C4C4C4', paddingVertical: 10, paddingHorizontal: 20 }}>
                    <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{t('note')}:</Text>
                    <Text style={{ fontSize: 12 }}>{this.rata.note}</Text>
                </View>

                <View style={{ marginTop: 50, width: 500, marginLeft: 50, height: 88 }}>
                    <View style={{ position: 'absolute', display: 'flex', left:0, width: 250, paddingVertical: 10, paddingHorizontal: 20, borderColor: '#C4C4C4', borderWidth: 1 }}>
                      <View style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                        <Text style={{ fontSize: 14 }}>{t('imponibile')}:</Text>
                        <Text style={{ fontSize: 12 }}> € {importoImponibile.toFixed(2)}</Text>
                      </View>
                      <View style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                        <Text style={{ fontSize: 14 }}>{t('iva_s')} (22%):</Text>
                        <Text style={{ fontSize: 12 }}> € {iva}</Text>
                      </View>
                      <View style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                        <Text style={{ fontSize: 14 }}>{t('sconto')}:</Text>
                        <Text style={{ fontSize: 12 }}> € 0.00</Text>
                      </View>
                    </View>
                    <View style={{ position: 'absolute', left: 249, width: 250, paddingVertical: 10, paddingHorizontal: 20, height: '100%', borderColor: '#C4C4C4', borderWidth: 1 }}>
                          <View style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <Text style={{ fontSize: 14 }}>{this.rata.status === 'PAGATA' ? t('totale_pagato_s') : t('totale_da_pagare')}:</Text>
                            <Text style={{ fontSize: 12 }}> € {(importoImponibile + parseFloat(iva)).toFixed(2)}</Text>
                          </View>
                          { this.rata.status !== "PAGATA" ? <View style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <Text style={{ fontSize: 10 }}>{t('scadenza_r')}:</Text>
                            <Text style={{ fontSize: 10 }}>{this.rata.data}</Text>
                          </View> : <View /> }
                         <View style={{ flexDirection: 'column', display: 'flex', justifyContent: 'space-between', marginTop: this.rata.status === "PAGATA" ? 20 : 10 }}>
                            <Text style={{ fontSize: 14 }}>{t('metodo_pagamento')}:</Text>
                            <Text style={{ fontSize: 12 }}>{this.rata.metodo ? t(this.rata.metodo) : '-'}</Text>
                          </View>
                    </View>
                </View>

                <View style={{ marginTop: 30, marginLeft: 50 }}>
                      <Text style={{ fontFamily: 'Courier-Oblique', fontSize: 10 }}>{t('maggiori_info')}: {this.cliente.mail} - {this.cliente.telefono}</Text>
                </View>
              </Page>
          </Document>
    </PDFViewer>
  </div>);
  }

}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    border:'1 solid #000',
    width: '90%',

  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    fontSize: 8,
    backgroundColor: '#ffffff',
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  weekEndOrangeDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
    backgroundColor: '#ffad18'
  },
  weekEndDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
    backgroundColor: '#ff0000'
  },
  weekDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
  },
});